<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading" v-title :data-title="detail.username">
    <div class="jbxx">
      <!-- 左 -->
      <div class="j_left">
        <div class="touximg d-c-c">
          <img
            :src="baseurl + detail.user.avatarUrl"
            v-if="detail.user.avatarUrl"
          />
          <img :src="baseurl + 'image/yhtx.png'" v-else />
          <img
            style="margin-left: 5px"
            v-img-url="detail.portrait"
            alt="人脸信息"
          />
        </div>
        <div>用户昵称 : {{ detail.user.nickName }}</div>
        <div>用户id : {{ detail.user_id }}</div>
        <div>支付宝绑定账号 : {{ detail.user.mobile }}</div>
        <div>银行卡号 : {{ detail.user.bank_card }}</div>
        <div>银行名称 : {{ detail.user.car_name }}</div>

        <div>户籍 : {{ detail.user.domicile }}</div>
        <!-- <div>生日 : {{ detail.user.birthday | formatDate1 }}</div> -->
        <div>生日 : {{ birthday }}</div>
        <div>性别 : {{ detail.user.gender == 1 ? "男" : "女" }}</div>

        <div
          class="touximg"
          @click="sfztz(baseurl + detail.portrait)"
          v-if="detail.portrait"
        >
          <img :src="baseurl + detail.portrait" />
        </div>
        <div class="touximg" v-else>
          <!-- 未认证人脸 -->
        </div>
      </div>
      <!-- 右 -->
      <div class="j_right">
        <div class="rleft">
          <div class="dingdan d-r d-s-c" style="line-height: 1.5">
            <div class="dd_title" style="width: 80px">订单状态：</div>
            <li class="d1">
              {{
                detail.order_status.value == 40 ? "已驳回" : detail.state_text
              }}
            </li>
            <li class="d2">用户: {{ detail.usernum ? "已实名" : "未实名" }}</li>
            <li class="d3">订单: {{ detail.usernum ? "已实名" : "未实名" }}</li>
          </div>
          <div>
            用户姓名：{{ detail.username }} 身份证号: {{ detail.usernum }}
          </div>
          <div>
            手机号：{{ detail.user.mobile }} 性别：{{ xingbie }} 年龄：{{ age }}
            <br />
            注册时间： {{ detail.create_time }}
          </div>
          <div>电子邮箱：{{ detail.user.email }} ip地址:{{ detail.ip }}</div>
          <div style="line-height: 25px">
            <div>
              本站租赁情况 <br />
              1、下单地区:
              <div v-if="detail.country">
                【 {{ detail.country ? detail.country : "" }}
                {{ detail.province ? detail.province : "" }}
                {{ detail.city ? detail.city : "" }}
                {{ detail.district ? detail.district : "" }} 】
              </div>
              <div v-else>【 用户未在手机上进行授权 】</div>
            </div>
            <div class="dd_title">审核提醒：</div>
            <div style="line-height: 2.2; margin: 0">
              <div @click="oderTotal()" style="margin: 0">
                1、相同收货地址共计
                <span class="xtsh">{{ dataCount.total }}</span>
                笔(该笔订单不计算在内)
              </div>

              2、下单和收货地相符 <br />

              3、相同ip下单地址共计
              {{ dataCount.ipcount }} 笔(该笔订单不计算在内)
              <br />

              4、该用户id有 {{ dataCount.user_idcount }} 笔租赁中订单;
              身份证匹配有 {{ dataCount.usernumcount }} 笔租赁中订单
            </div>
          </div>
        </div>
        <div class="rright" style="margin-left: 40px">
          <div @click="sfztz(detail.user.sfzpositive)">
            身份证正面：
            <img
              v-if="detail.user.sfzpositive"
              :src="detail.user.sfzpositive"
            />
            <img v-else />
          </div>
          <div @click="sfztz(detail.user.sfzback)">
            身份证反面：
            <img v-if="detail.user.sfzback" :src="detail.user.sfzback" />
            <img v-else />
          </div>
        </div>

        <div class="rright">
          <div @click="sfztz(detail.user.card_z)">
            公证身份证正面：
            <img v-if="detail.user.card_z" :src="detail.user.card_z" />
            <img v-else />
          </div>
          <div @click="sfztz(detail.user.card_f)">
            公证身份证反面：
            <img v-if="detail.user.card_f" :src="detail.user.card_f" />
            <img v-else />
          </div>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="nav" style="background-color: #fff !important">
      <div @click="ddxq(1)">
        <div :class="show == 1 ? 'dtclass' : ''">订单详情</div>
      </div>
      <div @click="ddxq(2)" v-if="riskCtrl.br_status === '1'">
        <div :class="show == 2 ? 'dtclass' : ''">百融风控报告</div>
      </div>
      <!-- <div @click="ddxq(3)">
        <div :class="show == 3 ? 'dtclass' : ''">征信报告V1</div>
      </div> -->
      <!-- <div @click="ddxq(10)">
        <div :class="show == 10 ? 'dtclass' : ''">征信报告V2</div>
      </div> -->
      <!-- <div @click="ddxq(14)" v-if="riskCtrl.zq_status === '1'">
        <div :class="show == 14 ? 'dtclass' : ''">掌签</div>
      </div> -->
      <div @click="ddxq(11)" v-if="riskCtrl.zq_status === '1'">
        <div :class="show == 11 ? 'dtclass' : ''">掌签征信报告</div>
      </div>
      <!-- <div @click="ddxq(4)">
        <div :class="show == 4 ? 'dtclass' : ''">欺诈分</div>
      </div> -->
      <!-- <div @click="ddxq(5)">
        <div :class="show == 5 ? 'dtclass' : ''">蚂蚁链代扣</div>
      </div> -->
      <div @click="ddxq(6)" v-if="riskCtrl.bl_status === '1'">
        <div :class="show == 6 ? 'dtclass' : ''">天狼星报告</div>
      </div>
      <!-- <div @click="ddxq(7)">
        <div :class="show == 7 ? 'dtclass' : ''">贷款报告</div>
      </div> -->
      <!-- <div @click="ddxq(8)">
        <div :class="show == 8 ? 'dtclass' : ''">逾期报告</div>
      </div> -->
      <div @click="ddxq(9)">
        <div :class="show == 9 ? 'dtclass' : ''">短信发送记录</div>
      </div>
      <div @click="ddxq(12)">
        <div :class="show == 12 ? 'dtclass' : ''">风控备注</div>
      </div>
      <div @click="ddxq(13)" v-if="riskCtrl.zxz_status === '1'">
        <div :class="show == 13 ? 'dtclass' : ''">租先知</div>
      </div>
      <div @click="ddxq(15)" v-if="riskCtrl.xy_status === '1'">
        <div :class="show == 15 ? 'dtclass' : ''">新颜</div>
      </div>
      <div @click="ddxq(16)" v-if="riskCtrl.zx_info_status === '1'">
        <div :class="show == 16 ? 'dtclass' : ''">浩程达</div>
      </div>
      <div @click="ddxq(17)">
        <div :class="show == 17 ? 'dtclass' : ''">蚂蚁风盾</div>
      </div>
      <div @click="ddxq(18)" v-if="riskCtrl.ls_report === '1'">
        <div :class="show == 18 ? 'dtclass' : ''">流水报告</div>
      </div>
    </div>

    <template v-if="show == 1">
      <div class="product-content">
        <!-- 个人信息 紧急联系人 -->
        <LIANXI :detailinfo="detail"></LIANXI>

        <!-- 担保人信息 -->
        <div class="common-form" v-if="JSON.stringify(order_surety).length > 0">
          担保人信息
        </div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          v-if="JSON.stringify(order_surety).length > 0"
        >
          <tr>
            <th>担保人姓名</th>
            <th>手机号</th>
            <th>身份证</th>
            <th>身份证正面</th>
            <th>身份证反面</th>
            <th>是否认证</th>
          </tr>
          <tr>
            <th>
              <span> {{ order_surety.userName }} </span>
            </th>
            <th>
              <span> {{ order_surety.mobile }} </span>
            </th>
            <th>
              <span> {{ order_surety.idCard }} </span>
            </th>
            <th>
              <!-- <span> {{ order_surety.idCard_front }} </span> -->
              <el-image
                fit="contain"
                style="width: 60px; height: 60px"
                v-if="order_surety.idCard_front"
                :src="order_surety.idCard_front"
                :preview-src-list="srcList1"
              >
              </el-image>
            </th>
            <th>
              <!-- <span> {{ order_surety.idCard_back }} </span> -->
              <el-image
                fit="contain"
                style="width: 60px; height: 60px"
                v-if="order_surety.idCard_back"
                :src="order_surety.idCard_back"
                :preview-src-list="srcList2"
              >
              </el-image>
            </th>
            <th>
              <span>
                {{ order_surety.face_status == 0 ? "未认证" : "已认证" }}
              </span>
            </th>
          </tr>
        </table>

        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>订单号</th>
            <th>买家</th>
            <th>订单金额 (元)</th>
            <th>运费金额 (元)</th>
            <th>优惠券抵扣 (元)</th>
            <th>实付款金额 (元)</th>
            <th>支付方式</th>
            <th>配送方式</th>
            <th>交易状态</th>
            <th>租赁期限</th>
            <th>租赁方式</th>
            <th>租赁时间</th>
            <th>是否已买断</th>
            <th>买断价</th>
            <th>买断时间</th>
            <th>下单渠道</th>
            <th>付款方式</th>
            <th>预收退款</th>
            <th>押金退款</th>
          </tr>
          <tr>
            <th>
              <span> {{ detail.order_no }} </span>
            </th>
            <th>
              <span> 用户ID({{ detail.user.user_id }}) </span>
            </th>
            <th>
              <span> {{ detail.order_price }} </span>
            </th>
            <th>
              <span> {{ detail.express_price }} </span>
            </th>
            <th>
              <span v-if="detail.coupon_money > 0">
                {{ detail.coupon_money }}
              </span>
            </th>
            <th>
              <span style="color: red"> {{ payable }} </span>
            </th>
            <th>
              <span>
                {{ detail.pay_type.value == 20 ? "支付宝支付" : "" }}
              </span>
            </th>
            <th>
              <span> {{ detail.delivery_type.text }}</span>
            </th>
            <th>
              <span>
                {{
                  detail.order_status.value == 40 ? "已驳回" : detail.state_text
                }}
              </span>
            </th>
            <th>
              <span> {{ leaseTerm }} 期 </span>
            </th>
            <th>
              <span>
                {{ detail.lease_type == 2 ? "租完买断" : "租完即送" }}</span
              >
            </th>
            <th>
              <span> {{ detail.create_time }} - {{ create_timedata }} </span>
            </th>
            <th>
              <span> {{ detail.maiduan_no ? "是" : "否" }} </span>
            </th>
            <th>
              <span> {{ detail.maiduan_no ? buy_out_price : "" }}</span>
            </th>
            <th>
              <span v-if="detail.maiduan_no">
                {{ detail.maiduantime | formatDate }}
              </span>
              <span v-else> </span>
            </th>
            <th><span> 支付宝小程序 </span></th>
            <th><span> 按月支付 </span></th>
            <th style="color: red">
              {{ detail.ys_fail_msg ? detail.ys_fail_msg2 : "无" }}
            </th>
            <th style="color: red">
              {{ detail.yj_fail_msg ? detail.yj_fail_msg1 : "无" }}
            </th>
          </tr>
        </table>

        <!--赋强公证-->
        <!-- <div class="common-form">赋强公证</div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>公证核验</th>
            <th>公证审核</th>
            <th>公证受理</th>
            <th>操作</th>
          </tr>
          <tr>
            <th>
              <span v-if="detail.apply_Status == ''">未核验</span>
              <span
                style="color: #1890ff"
                v-else-if="detail.apply_Status == 'Verified'"
                >待核验</span
              >
              <span style="color: #67c23a" v-else>已核验</span>
            </th>
            <th>
              <span
                style="color: #1890ff"
                v-if="detail.apply_Status == 'Pending'"
                >待受理</span
              >
              <span
                style="color: #67c23a"
                v-else-if="detail.apply_Status == 'Rejected'"
                >已驳回</span
              >
              <span
                style="color: #67c23a"
                v-else-if="detail.apply_Status == 'Accepted'"
                >已受理</span
              >
              <span
                style="color: #67c23a"
                v-else-if="detail.apply_Status == 'Passed'"
                >已通过</span
              >
              <span v-else>未审核</span>
            </th>
            <th>
              <span
                style="color: #1890ff"
                v-if="detail.apply_Status == 'NoPass'"
                >不通过</span
              >
              <span
                style="color: #67c23a"
                v-else-if="detail.apply_Status == 'Passed'"
                >已通过</span
              >
              <span v-else>未受理</span>
            </th>
            <th>
              <el-button type="primary" @click="dialogReason = true"
                >取消</el-button
              >
              <el-button type="primary" @click="tYFqgz()">同意</el-button>
              <el-button type="primary" @click="rejectFqgz()">拒绝</el-button>
              <el-button type="primary" @click="queryApplyInfo()"
                >查看合同</el-button
              >
              <el-button type="primary" @click="gogz()">查看公证书</el-button>
            </th>
          </tr>
        </table> -->
        <div class="common-form">鹭江公证</div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>公证状态</th>
            <th>操作</th>
          </tr>
          <tr>
            <th>
              <span v-if="detail.lujiang.text == null">未上传</span>
              <span style="color: #67c23a" v-else>{{
                detail.lujiang.text
              }}</span>
            </th>
            <th>
              <el-button type="primary" @click="goInfo()">刷新</el-button>
              <el-button type="primary" @click="gosilenceSign()"
                >公证文件签署</el-button
              >
              <el-button
                type="primary"
                @click="createOrder()"
                v-if="detail.lujiang.text == null"
                >发起公证</el-button
              >
              <el-button type="primary" @click="downNotaryOrderBtn()"
                >下载公证书</el-button
              >
              <el-button
                type="primary"
                @click="cancleOrder()"
                v-if="detail.lujiang.value == 10 || detail.lujiang.value == 20"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="applyCert(1)"
                v-if="detail.lujiang.value == 22"
                >同意</el-button
              >
              <el-button
                type="primary"
                @click="applyCert(0)"
                v-if="detail.lujiang.value == 22"
                >拒绝</el-button
              >
              <el-button type="primary" @click="getlujiangCode()"
                >获取二维码</el-button
              >
              <el-button type="primary" @click="certificationClear()"
                >公证撤销</el-button
              >
            </th>
          </tr>
        </table>

        <!-- 资金预授权--芝麻信息 -->
        <div class="common-form">
          资金预授权--芝麻信息(如果为空则无资金授权押金冻结)
        </div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>累计冻结金额(元)</th>
            <th>信用金额(元)</th>
            <th>预交押金记录(元)</th>
            <th>支付宝资金预授权订单号</th>
            <th>预授权类型</th>
            <th>支付宝账号</th>
            <th>创建时间</th>
            <th>状态</th>
            <th>驳回时间</th>
          </tr>
          <tr>
            <th>
              <span> {{ detail.deposit }} </span>
            </th>
            <th>
              <span> {{ detail.deposit }} </span>
            </th>
            <th>
              <span> {{ ysqyjze }} </span>
            </th>
            <th>
              <span> {{ detail.auth_no }} </span>
            </th>
            <th><span>信用预授权 </span></th>
            <th>
              <span> {{ detail.user.open_id }} </span>
            </th>
            <th>
              <span> {{ detail.create_time }} </span>
            </th>
            <th>
              <span style="color: red" v-if="detail.order_status.value != 40">
                {{ detail.auth_no ? "已支付" : "未支付" }}
              </span>
              <span style="color: red" v-else>
                {{
                  detail.order_status.value == 40 ? "已驳回" : detail.state_text
                }}
              </span>
            </th>
            <th>
              <span v-if="detail.bhtime != 0">
                {{ detail.bhtime | formatDate }}
              </span>
            </th>
          </tr>
        </table>

        <!-- 预收租金 -->
        <div class="common-form">预收租金</div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>订单号</th>
            <th>增加金额(元)</th>
            <th>支付宝资金回调订单号</th>
            <th>创建时间</th>
            <th>是否选择了碎屏险</th>
            <th>状态</th>
            <th>驳回时间</th>
          </tr>
          <tr>
            <th>
              <span> {{ ysinfo.order_no }} </span>
            </th>
            <th>
              <span> {{ detail.yushou }} </span>
            </th>
            <th>
              <span> {{ ysinfo.transaction_id }} </span>
            </th>
            <th>
              <span> {{ ysinfo.create_time }} </span>
            </th>
            <th>
              <span> {{ sphxInfo }} </span>
            </th>
            <th>
              <span style="color: red" v-if="detail.order_status.value != 40">
                {{ ysinfo.transaction_id ? "已支付" : "未支付" }}
              </span>
              <span style="color: red" v-else>
                {{
                  detail.order_status.value == 40 ? "已驳回" : detail.state_text
                }}
              </span>
            </th>
            <th>
              <span v-if="detail.bhtime != 0">
                {{ detail.bhtime | formatDate }}
              </span>
            </th>
          </tr>
        </table>

        <div class="common-form">碎屏险</div>
        <table
          border="1"
          style="border-collapse: collapse; width: 100%"
          class="color49"
        >
          <tr>
            <th>下单碎屏险</th>
            <th>金额(元)</th>
            <th>支付状态</th>
          </tr>
          <tr>
            <th>{{ sphxInfo }}</th>
            <th>￥499</th>
            <th>
              <span style="color: red" v-if="detail.order_status.value != 40">
                {{ ysinfo.transaction_id ? "已支付" : "未支付" }}
              </span>
              <span style="color: red" v-else>
                {{
                  detail.order_status.value == 40 ? "已驳回" : detail.state_text
                }}
              </span>
            </th>
          </tr>
        </table>

        <!-- 密码弹窗 -->
        <el-dialog
          title="请输入密码"
          :visible.sync="dialogVisiblezdhk"
          width="20%"
        >
          <div style="height: 100px">
            <el-input
              placeholder="请输入密码"
              v-model="zdhkinput"
              show-password
            ></el-input>
            <div
              style="margin-top: 20px; display: flex; justify-content: center"
            >
              <el-button type="primary" @click="zdhkqd()">确定</el-button>
            </div>
          </div>
        </el-dialog>
        <!-- 租后管理 -->
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="common-form">租后管理</div>
        </div>
        <div>
          <div style="width: 100%;">
            <!-- 表头 -->
            <div style="display: flex;" class="bill-header">
              <div style="flex:1">期数</div>
              <div style="flex:1">应还款金额(元)</div>
              <div style="flex:1">订单编号</div>
              <div style="flex:1">扣款时间</div>
              <div style="flex:1">订单状态</div>
              <div style="flex:1">支付时间</div>
              <div style="flex:1">操作</div>
            </div>
            <!-- 表格内容 -->
            <div v-for="(item, index) in orderBill" :key="item.bill_id">
              <!-- 父级行 -->
              <div class="bill-row" style="display: flex;">
                <div style="flex:1;line-height: 40px;">
                  {{ item.current_period }}
                </div>
                <div style="flex:1;line-height: 40px;">{{ item.price }}</div>
                <div style="flex:1;line-height: 40px;">{{ item.bill_id }}</div>
                <div style="flex:1;line-height: 40px;">
                  {{ item.repayment_date | formatDate }}
                </div>
                <div style="flex:1;line-height: 40px;">
                  <template>
                    <div v-if="item.jieguo == '未还'" style="color: #ff0000">
                      {{ item.jieguo }}
                    </div>
                    <div
                      v-if="item.jieguo == '已还'"
                      style="color: cornflowerblue"
                    >
                      {{ item.jieguo }}
                    </div>
                    <div v-if="item.jieguo == '逾期'">
                      {{ item.jieguo }}
                    </div>
                  </template>
                </div>
                <div style="flex:1;line-height: 40px;">
                  {{
                    item.paytime == 0
                      ? "未支付"
                      : formattedUTCTime(item.paytime)
                  }}
                </div>
                <div style="flex:1;line-height: 40px;">
                  <div v-if="detail.order_id > 850">
                    <el-dropdown
                      split-button
                      v-if="
                        !item.is_top_row &&
                          alipayBigOrder !== null &&
                          alipayBigOrder.status != 'CREATED'
                      "
                    >
                      更多操作
                      <el-dropdown-menu
                        slot="dropdown"
                        style="padding: 5px; box-shadow: 0 0 1px 1px #3333"
                      >
                        <div class="anniu">
                          <el-button
                            @click="bigOrderActive(item)"
                            type="warning"
                            size="mini"
                            v-if="item.is_pay_status !== '已还'"
                            style="width: 104px"
                            >主动还款</el-button
                          >
                        </div>
                        <div
                          class="anniu"
                          size="mini"
                          style="width: 104px"
                          v-if="
                            item.kkTime &&
                              item.jieguo == '未还' &&
                              item.jieguo == '逾期'
                          "
                        >
                          <el-button
                            @click="deductMoney(item)"
                            type="danger"
                            size="mini"
                            style="width: 104px"
                            >扣款</el-button
                          >
                        </div>
                        <div class="anniu">
                          <el-button
                            type="primary"
                            v-if="item.is_pay_status !== '已还'"
                            style="width: 104px"
                            size="mini"
                            @click="bigOrderDaikou(item)"
                            >大订单代扣</el-button
                          >
                        </div>
                        <!-- <div class="anniu" v-if="item.current_period !== lease_time">
                          <el-button @click="repay(item)" type="danger" size="mini"
                            style="width: 104px">还款</el-button>
                        </div> -->
                        <div class="anniu">
                          <el-button
                            size="mini"
                            type="warning"
                            style="width: 104px"
                            v-if="
                              item.is_pay_status == '已还' &&
                                item.refund_status == 0
                            "
                            @click="bigOrderRefund(item)"
                            >退款</el-button
                          >
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <!-- 子级行 -->
              <div
                v-if="item.split_list && item.split_list.length > 0"
                class="bill-children"
              >
                <div
                  v-for="(child, childIndex) in item.split_list"
                  :key="child.bill_id"
                  class="bill-row"
                  style="display: flex; background-color: #f5f7fa;"
                >
                  <div style="flex:1;line-height: 40px;">
                    {{ child.current_period }}
                  </div>
                  <div style="flex:1;line-height: 40px;">{{ child.price }}</div>
                  <div style="flex:1;line-height: 40px;">
                    {{ child.bill_split_id }}
                  </div>
                  <div style="flex:1;line-height: 40px;">
                    {{ child.repayment_date | formatDate }}
                  </div>
                  <div style="flex:1;line-height: 40px;">
                    <div v-if="child.refund_status == 0">
                      <div
                        v-if="child.is_pay_status == 0"
                        style="color: #ff0000"
                      >
                        未还
                      </div>
                      <div
                        v-if="child.is_pay_status == 1"
                        style="color: cornflowerblue"
                      >
                        已还
                      </div>
                      <div v-if="child.is_pay_status == 2">
                        逾期
                      </div>
                    </div>
                    <div v-else>
                      已退款
                    </div>
                  </div>
                  <div style="flex:1;line-height: 40px">
                    {{
                      child.paytime == 0
                        ? "未支付"
                        : formattedUTCTime(child.paytime)
                    }}
                  </div>
                  <div
                    style="flex:1;line-height: 40px"
                    v-if="detail.order_id <= 850"
                  >
                    <el-dropdown split-button>
                      更多操作
                      <el-dropdown-menu
                        slot="dropdown"
                        style="padding: 5px; box-shadow: 0 0 1px 1px #3333;"
                      >
                        <div class="anniu">
                          <el-button
                            @click="zdhk1(child)"
                            type="warning"
                            size="mini"
                            v-if="child.is_pay_status !== '已还'"
                            style="width: 104px"
                            >主动还款</el-button
                          >
                        </div>
                        <div class="anniu">
                          <el-button
                            @click="recovery(child)"
                            type="primary"
                            size="mini"
                            style="width: 104px"
                          >
                            恢复代扣
                          </el-button>
                        </div>
                        <div
                          class="anniu"
                          v-if="child.is_pay_status === '未还'"
                        >
                          <el-button
                            @click="openRepayDialog(child)"
                            type="success"
                            size="mini"
                            style="width: 104px"
                            >代扣报送</el-button
                          >
                        </div>
                        <div
                          class="anniu"
                          v-if="child.is_pay_status === '未还'"
                        >
                          <el-button
                            @click="createActivePay(child)"
                            type="warning"
                            size="mini"
                            style="width: 104px"
                            >代扣</el-button
                          >
                        </div>
                        <div class="anniu">
                          <el-button
                            @click="stagingRefund(child)"
                            type="warning"
                            size="mini"
                            style="width: 104px"
                            >分期退款</el-button
                          >
                        </div>
                        <div class="anniu">
                          <el-button
                            @click="billRefund(child)"
                            type="warning"
                            size="mini"
                            style="width:104px"
                            >退款</el-button
                          >
                        </div>
                        <div
                          class="anniu"
                          v-if="child.is_pay_status === '未还'"
                        >
                          <el-button
                            @click="getUserTradeInfo(child)"
                            type="warning"
                            size="mini"
                            style="width: 104px"
                            >代扣结果查询</el-button
                          >
                        </div>
                        <div class="anniu" v-else>
                          <el-button
                            @click="repay(child)"
                            type="danger"
                            size="mini"
                            style="width: 104px"
                            >结清</el-button
                          >
                        </div>
                        <div
                          class="anniu"
                          v-if="
                            child.is_pay_status === '逾期' &&
                              child.is_bad_debts === 0
                          "
                        >
                          <el-button
                            size="mini"
                            type="danger"
                            style="width: 104px"
                            @click="billDebt(child.bill_id, 1)"
                            >标记坏账</el-button
                          >
                        </div>
                        <div class="anniu" v-if="child.is_bad_debts === 1">
                          <el-button
                            size="mini"
                            type="danger"
                            style="width: 104px"
                            @click="billDebt(child.bill_id, 0)"
                            >取消坏账</el-button
                          >
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 租期 -->

        <div class="common-form">费用信息</div>
        <table border="1" style="border-collapse: collapse; width: 100%">
          <tr>
            <th>订单总金额(￥)</th>
            <th>收取押金(￥)</th>
            <th>单价</th>
            <th>优惠金额(￥)</th>
            <th>已付款金额(￥)</th>
            <th>待支付金额(￥)</th>
          </tr>
          <tr>
            <th>
              <span> {{ detail.order_price }} </span>
            </th>
            <th>
              <span> {{ ysqyjze }} </span>
            </th>
            <th>
              <span> {{ detail.product[0].product_name }} </span>
            </th>
            <th>
              <span> {{ coupon_money }} </span>
            </th>
            <th>
              <span> {{ pricezq }} </span>
            </th>
            <th>
              <span> {{ weihuan }} </span>
            </th>
          </tr>
        </table>

        <!-- 弹窗 -->
        <el-dialog title="布尔征信" :visible.sync="dialogTableVisible1">
        </el-dialog>
        <!-- 弹窗 -->
        <el-dialog title="布尔征信" :visible.sync="dialogTableVisible2">
        </el-dialog>

        <!--商户信息-->
        <div class="common-form mt16">商户信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">商户名称：</span>
                {{ detail.supplier.name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系人：</span>
                {{ detail.supplier.link_name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.supplier.link_phone }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">地址：</span>
                {{ detail.supplier.address }}
              </div>
            </el-col>
          </el-row>
        </div>
        <!--商品信息-->
        <div class="common-form mt16">商品详情</div>
        <div class="table-wrap">
          <el-table
            size="small"
            :data="detail.product"
            border
            style="width: 100%"
          >
            <el-table-column label="商品" width="400">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic">
                    <img v-img-url="scope.row.image.file_path" />
                  </div>
                  <div class="info">
                    <div class="name">{{ scope.row.product_name }}</div>
                    <div class="gray9" v-if="scope.row.product_attr != ''">
                      {{ scope.row.product_attr }}
                    </div>
                    <div class="orange" v-if="scope.row.refund !== null">
                      {{ scope.row.refund.type.text }}-{{
                        scope.row.refund.status.text
                      }}
                    </div>
                    <div class="price">
                      <span
                        :class="{
                          'text-d-line': scope.row.is_user_grade == 1,
                          gray6: scope.row.is_user_grade != 1
                        }"
                        >￥ {{ scope.row.product_price }}</span
                      >
                      <span class="ml10" v-if="scope.row.is_user_grade == 1">
                        会员折扣价：￥ {{ scope.row.grade_product_price }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="product_no"
              label="商品编码"
            ></el-table-column>
            <el-table-column
              prop="product_weight"
              label="重量 (Kg)"
            ></el-table-column>
            <el-table-column prop="total_num" label="购买数量">
              <template slot-scope="scope">
                <p>x {{ scope.row.total_num }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="商品总价(元)">
              <template slot-scope="scope">
                <p>￥ {{ detail.order_price }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="total_price"
              label="补充文件"
              v-if="supply_files.length > 0"
            >
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="changeSupplyFile">
                  查看文件
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--收货信息-->
        <div v-if="detail.delivery_type.value == 10 && detail.express_image == ''">
          <div class="common-form mt16">收货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">收货人：</span>
                  {{ detail.address.name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">收货电话：</span>
                  {{ detail.address.phone }}
                </div>
              </el-col>
              <el-col :span="9">
                <div class="pb16">
                  <span class="gray9">收货地址：</span>
                  {{ detail.address.region.province }}
                  {{ detail.address.region.city }}
                  {{ detail.address.region.region }}
                  {{ detail.address.detail }}
                </div>
              </el-col>
              <el-col :span="5" v-if="detail.delivery_status.value != 20">
                <div class="pb16">
                  <el-button type="text" size="small" @click="changeAdd">
                    修改地址
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!--自提门店信息-->
        <template v-if="detail.express_image != ''">
          <div class="common-form mt16">自提用户信息</div>
          <div class="table-wrap" v-if="detail.extract">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系人：</span>
                  {{ detail.extract.linkman }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系电话：</span>
                  {{ detail.extract.phone }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="common-form mt16">自提信息</div>
          <div class="table-wrap" v-if="detail.extract">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">门店ID:</span>
                  {{ detail.extractStore.store_id }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">门店名称：</span>
                  {{ detail.extractStore.store_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系人：</span>
                  {{ detail.extractStore.linkman }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系电话：</span>
                  {{ detail.extractStore.phone }}
                </div>
              </el-col>
              <el-col :span="15">
                <div class="pb16">
                  <span class="gray9">门店地址：</span>
                  {{ detail.extractStore.region.province }}-
                  {{ detail.extractStore.region.city }}-
                  {{ detail.extractStore.region.region }}-
                  {{ detail.extractStore.address }}
                </div>
              </el-col>
            </el-row>
          </div>
        </template>

        <!--无需发货-->
        <template v-if="detail.delivery_type.value == 30">
          <div class="common-form mt16">用户信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系手机：</span>
                  {{ detail.user.mobile }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </template>

        <!--付款信息-->
        <!-- <div class="table-wrap" v-if="detail.pay_status.value == 20">
            <div class="common-form mt16">付款信息</div>
            <div class="table-wrap">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">应付款金额：</span>
                    {{ detail.pay_price }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">支付方式：</span>
                    {{ detail.pay_type.text=='微信支付'?'支付宝支付':'支付宝支付' }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">支付流水号：</span>
                    {{ detail.transaction_id }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">付款状态：</span>
                    {{ detail.pay_status.text }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">付款时间：</span>
                    {{ detail.pay_time }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div> -->

        <!--发货信息-->
        <div
          v-if="
            detail.pay_status.value == 20 &&
              detail.delivery_type.value == 10 &&
              [20, 21].indexOf(detail.order_status.value) === -1
          "
          v-auth="'/order/order/delivery'"
        >
          <div v-if="detail.delivery_status.value == 10">
            <!-- 去发货 -->
            <div class="common-form mt16">去发货</div>
            <el-form size="small" ref="form" :model="form" label-width="100px">
              <el-form-item label="物流公司">
                <el-select
                  v-model="form.express_id"
                  placeholder="请选择快递公司"
                >
                  <el-option
                    :label="item.express_name"
                    v-for="(item, index) in expressList"
                    :key="index"
                    :value="item.express_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-input v-model="form.express_no" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input
                  v-model="form.equipment_no"
                  class="max-w460"
                ></el-input>
              </el-form-item>
              <el-form-item label="发货方式">
                <el-radio-group v-model="form.is_delivery">
                  <el-radio :label="10">物流发货</el-radio>
                  <el-radio :label="20">门店自提</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div v-else>
            <div class="common-form mt16">发货信息</div>
            <div class="table-wrap">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">物流公司：</span>
                    {{ detail.express.express_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16" style="color: #0043ff">
                    <span class="gray9">物流单号：</span>
                    {{ detail.express_no }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">设备编号：</span>
                    {{ detail.equipment_no }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货状态：</span>
                    {{ detail.delivery_status.text }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货方式：</span>
                    {{ detail.delivery_type.text }}
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="pb16">
                    <span class="gray9">操作：</span>
                    <span
                      style="color: #0043ff; cursor: pointer"
                      @click="xiugai()"
                      >修改</span
                    >
                    <span
                      style="color: #0043ff; cursor: pointer"
                      @click="wldh()"
                      >查询</span
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>

        <!-- 物流修改弹窗 -->
        <el-dialog
          title="物流信息"
          :visible.sync="dialogVisiblewlfh"
          width="60%"
        >
          <div>
            <div class="common-form mt16">去发货</div>
            <el-form size="small" ref="form" :model="form" label-width="100px">
              <el-form-item label="物流公司">
                <el-select
                  v-model="detail.express_id"
                  placeholder="请选择快递公司"
                >
                  <el-option
                    :label="item.express_name"
                    v-for="(item, index) in expressList"
                    :key="index"
                    :value="item.express_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-input
                  v-model="detail.express_no"
                  class="max-w460"
                ></el-input>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input
                  v-model="detail.equipment_no"
                  class="max-w460"
                ></el-input>
              </el-form-item>
              <el-form-item label="发货方式">
                <el-radio-group v-model="detail.delivery_type.value">
                  <el-radio :label="10">物流发货</el-radio>
                  <el-radio :label="20">门店自提</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div style="margin-top: 10px">
              <el-button @click="orderqd()">确 定</el-button>
              <el-button @click="dialogVisiblewlfh = false">取 消</el-button>
            </div>
          </div>
        </el-dialog>

        <!--门店自提核销-->
        <div
          v-if="
            detail.delivery_type.value == 20 &&
              detail.pay_status.value == 20 &&
              detail.order_status.value != 21 &&
              detail.order_status.value != 20
          "
          v-auth="'/order/order/operate/extract'"
        >
          <div class="common-form mt16">门店自提核销</div>
          <div v-if="detail.delivery_status.value == 10">
            <el-form
              size="small"
              ref="extract_form"
              :model="extract_form"
              label-width="100px"
            >
              <el-form-item label="门店核销员">
                <el-select
                  v-model="extract_form.order.extract_clerk_id"
                  placeholder="点击选择"
                >
                  <el-option
                    :label="item.real_name"
                    v-for="(item, index) in shopClerkList"
                    :key="item.clerk_id"
                    :value="item.clerk_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="买家取货状态 ">
                <el-radio v-model="extract_form.order.extract_status" :label="1"
                  >已取货</el-radio
                >
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onExtract(detail.order_id)"
                  >确认核销</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div v-else class="table-wrap">
            <template v-if="detail.extractClerk">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">自提门店名称：</span>
                    {{ detail.extractStore.store_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销员：</span>
                    {{ detail.extractClerk.real_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已核销
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <!--取消信息-->
        <div
          class="table-wrap"
          v-if="detail.order_status.value == 20 && detail.cancel_remark != ''"
        >
          <div class="common-form mt16">取消信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">商家备注：</span>
                  {{ detail.cancel_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!--门店自提核销-->
        <div
          v-if="
            detail.delivery_type.value == 20 &&
              detail.pay_status.value == 20 &&
              detail.order_status.value != 21 &&
              detail.order_status.value != 20
          "
        >
          <div class="common-form mt16">门店自提核销</div>
          <div class="table-wrap">
            <template v-if="detail.extractClerk">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">自提门店名称：</span>
                    {{ detail.extractStore.store_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销员：</span>
                    {{ detail.extractClerk.real_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已核销
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <!--虚拟物品发货-->
        <div
          v-if="
            detail.delivery_type.value == 30 &&
              detail.pay_status.value == 20 &&
              detail.order_status.value != 21 &&
              detail.order_status.value != 20
          "
          v-auth="'/order/order/delivery'"
        >
          <div class="common-form mt16">虚拟商品发货</div>
          <div v-if="detail.delivery_status.value == 10">
            <div class="pb16"><span class="gray9">发货状态：</span>待发货</div>
          </div>
          <div v-else class="table-wrap">
            <template v-if="detail.virtual_content">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货信息：</span>
                    {{ detail.virtual_content }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已发货
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
      </div>

      <div class="common-form mt16">操作信息</div>
      <el-table :data="beizhu" style="width: 100%">
        <el-table-column prop="user_name" label="操作者"> </el-table-column>
        <el-table-column prop="create_time" label="操作时间" width="180">
        </el-table-column>
        <el-table-column prop="type" label="订单状态"> </el-table-column>
        <el-table-column prop="content" label="备注"> </el-table-column>
      </el-table>

      <!-- 物流弹框 -->
      <el-dialog title="物流状况" :visible.sync="dialogVisiblewl" width="50%">
        <el-table :data="wlList" style="width: 100%" height="600">
          <el-table-column prop="areaCode" label="Code"> </el-table-column>
          <el-table-column prop="areaName" label="地区"> </el-table-column>
          <el-table-column prop="context" label="内容"> </el-table-column>
          <el-table-column prop="ftime" label="时间"> </el-table-column>
          <el-table-column prop="status" label="状态"> </el-table-column>
          <el-table-column prop="time" label="时间"> </el-table-column>
        </el-table>
      </el-dialog>

      <!-- 添加备注弹框 -->
      <el-dialog
        title="添加商家备注"
        :visible.sync="dialogVisibletjbz"
        width="40%"
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 130px;
          "
        >
          <div style="width: 20%">备注：</div>
          <el-input v-model="tjbzinput" placeholder="备注"></el-input>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <el-button @click="dialogVisibletjbz = false">关闭</el-button>
          <el-button type="success" @click="tijiaobz()">提交</el-button>
        </div>
      </el-dialog>

      <div class="common-button-wrapper">
        <el-button type="primary" @click="shuaxin()">刷新</el-button>
        <el-button type="primary" @click="tjbz()">添加备注</el-button>
        <!-- <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button> -->
        <el-button
          v-if="detail.order_status.text == '待审核'"
          size="small"
          type="primary"
          @click="showShenhe"
          >审核该订单</el-button
        >
        <!--确认发货-->
        <template
          v-if="
            detail.pay_status.value == 20 &&
              detail.delivery_type.value == 10 &&
              [20, 21].indexOf(detail.order_status.value) === -1
          "
        >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            v-if="detail.delivery_status.value == 10"
            >确认发货
          </el-button>
        </template>
        <!--用户取消-->
        <template
          v-if="
            detail.pay_status.value == 20 && detail.order_status.value == 21
          "
        >
          <el-button size="small" type="primary" @click="confirmCancel()"
            >确认审核</el-button
          >
        </template>
      </div>

      <changeAddress
        :isChange="isChange"
        :addressData="addressData"
        @closeDialog="closeAddress"
      ></changeAddress>
      <!-- <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" :order="shneheList" @close="closeShenhe($event, 'edit')"></Shen> -->
      <Shen
        v-if="shenhe"
        :open_edit="shenhe"
        :order_id="order_id"
        @close="closeShenhe($event, 'edit')"
      ></Shen>
    </template>
    <template v-if="show == 2">
      <Fengkon :fkid="detail.user_id" :order_id="detail.order_id"></Fengkon>
    </template>
    <template v-if="show == 3">
      <ZHENGXIN
        :zxid="detail.user_id"
        :order_id="detail.order_id"
        :zxid2="detail.sirius_report"
      ></ZHENGXIN>
    </template>
    <template v-if="show == 10">
      <ZHENGXINA
        :list="creditInvestigationList"
        :order_id="detail.order_id"
        :zxid2="detail.sirius_report"
        :zxid="detail.user_id"
      ></ZHENGXINA>
    </template>
    <template v-if="show == 11">
      <YHZX
        :xml="xml_data"
        :order_id="detail.order_id"
        :user_id="detail.user_id"
        :list="creditInvestigationList"
        :zxid2="detail.sirius_report"
        :hrzx_authorization="detail.authorization_agreement"
      ></YHZX>
    </template>
    <template v-if="show == 4">
      <YIDUN
        :zxid="detail.order_id"
        :ant_shield="detail.ant_shield"
        :auth_no="detail.auth_no"
      ></YIDUN>
    </template>
    <template v-if="show == 5">
      <MAYILIANDAIKOU
        :folwid2="detail.folwid2"
        :myloid="detail.order_id"
      ></MAYILIANDAIKOU>
    </template>
    <template v-if="show == 6">
      <BUERZHENGXIN
        :order_id="detail.order_id"
        :user_id="detail.user_id"
        :credit_report="detail.credit_report"
        :tlx_report="detail.tlx_report"
      >
      </BUERZHENGXIN>
    </template>
    <template v-if="show == 7">
      <DAIKUANBAOGAO
        :order_id="detail.order_id"
        :query3="detail.query3_testBooleanDemo"
      ></DAIKUANBAOGAO>
    </template>
    <template v-if="show == 8">
      <YUQIBAOGAO
        :order_id="detail.order_id"
        :query4="detail.query4_testBooleanDemo"
      ></YUQIBAOGAO>
    </template>
    <template v-if="show == 9">
      <DUANXIN :order_id="detail.order_id"></DUANXIN>
    </template>
    <template v-if="show == 12">
      <!-- <REMARK :order_id="detail.order_id"></REMARK> -->
      <REMARK :order_id="detail.order_id" :detail="detail"></REMARK>
    </template>
    <template v-if="show == 13">
      <ZUXIANZHI
        :report="zuxz"
        :order_id="detail.order_id"
        :user-info="detail.user"
      ></ZUXIANZHI>
    </template>
    <template v-if="show == 14">
      <ZHANGQIAN :order_id="detail.order_id"></ZHANGQIAN>
    </template>
    <template v-if="show == 15">
      <XINYAN
        :report="zuxz"
        :order_id="detail.order_id"
        :user-info="detail.user"
      ></XINYAN>
    </template>
    <template v-if="show == 16">
      <HZCreditReport
        :detail="detail"
        :credit_url="credit_url"
      ></HZCreditReport>
    </template>
    <template v-if="show == 17">
      <wind-shied
        :riskInfo="detail.spring"
        :orderId="detail.order_id"
        @refresh="getParams"
      ></wind-shied>
    </template>
    <template v-if="show == 18">
      <LSREPORT :reportUrl="reportUrl"></LSREPORT>
    </template>
    <!-- 以租代购手机照片 -->
    <div class="dialogFile">
      <el-dialog title="手机信息图片" :visible.sync="dialogFile" width="60%">
        <el-button type="primary" @click="reasonPass()">通过</el-button>
        <el-button type="primary" @click="reasonRefusal()">驳回</el-button>
        <div v-for="item in supply_files">
          <div
            style="
              height: 40px;
              line-height: 40px;
              font-size: 14px;
              font-weight: 700;
              margin-bottom: 12px;
            "
          >
            {{ item.file_name }}
          </div>
          <div
            style="
              display: flex;
              flex-wrap: wrap;
              overflow: hidden;
              padding: 0 0 0 2vw;
              box-sizing: border-box;
            "
          >
            <!-- <div v-for="(index) in item.images" style="    width: 30%;margin-left: 2vw;"> -->
            <img
              :src="item.images"
              style="width: 50%"
              alt="Example Image"
              @click="openImageInNewTab(item.images)"
            />
            <!-- </div> -->
          </div>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="驳回" :visible.sync="dialogVisible" width="30%">
      <!-- <el-radio v-model="radio" :label="1">通过</el-radio> -->
      <el-radio v-model="radio" :label="2">驳回</el-radio>
      <el-input
        v-model="input"
        placeholder="请输入备注信息"
        style="margin-top: 10px"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFunc()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 相同收货地址弹框 -->
    <el-dialog
      title="相同收货地址信息"
      :visible.sync="dialogVisiblexd"
      width="60%"
    >
      <div>
        <el-table :data="orderList" style="width: 100%" max-height="530">
          <el-table-column label="订单号">
            <template slot-scope="scope">
              <span
                style="color: #3c8dc2; cursor: pointer"
                @click="tiaozdd(scope.row.order_id)"
                >{{ scope.row.orderlist.order_no }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="d4">
                {{
                  scope.row.orderlist.order_status.value == 40
                    ? "已驳回"
                    : scope.row.orderlist.state_text
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{
                scope.row.orderlist.username
                  ? scope.row.orderlist.username
                  : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <span>
                {{ scope.row.region.province }} {{ scope.row.region.city }}
                {{ scope.row.region.region }} {{ scope.row.detail }}</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 逾期弹框 -->
    <el-dialog title="逾期" :visible.sync="dialogyq" width="60%">
      <div>
        <el-form size="small" ref="jqform" :model="form" label-width="100px">
          <el-form-item label="金额(元)">
            <el-input v-model="jqform.value" class="max-w460"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="jqform.type" placeholder="请选择类型">
              <el-option
                :label="item.type"
                v-for="(item, index) in jieqingList"
                :key="index"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-top: 10px">
          <el-button @click="orderjq()">确 定</el-button>
          <el-button @click="dialogyq = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 公证取消原因 -->
    <el-dialog title="提示" :visible.sync="dialogReason" width="30%">
      <el-input v-model="reason" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReason = false">取 消</el-button>
        <el-button type="primary" @click="reasonData()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="二维码" :visible.sync="showLJCodeDia" width="30%">
      <div>
        <img :src="LJCodeUrl" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLJCodeDia = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改订单支付状态" :visible.sync="changeOrderStatusVis">
      <el-form ref="" size="small">
        <el-form-item label="">
          我要反馈
          <el-input
            type="textarea"
            v-model="orderStatus.description"
            placeholder="输入续租申请内容/改价内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          上传凭证
          <el-upload
            action=""
            list-type="picture-card"
            :accept="accept"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="UploadImage"
          >
            <i class="el-icon-plus"></i>
            <template #file="{ file }">
              <img :src="file.url" class="el-upload-list__item-thumbnail" />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePicturePreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
              </span>
            </template>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: flex-end">
            <el-button type="primary" @click="statusSubmit">确 定</el-button>
            <el-button @click="changeOrderStatusVis = false">取 消</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <AntRepay ref="antRepayRef" />
    <el-dialog :visible="tongVis" title="通过信息" @close="tongVis = false">
      <el-form :label-width="80">
        <el-form-item label="备注">
          {{ tongMsg.description }}
        </el-form-item>
        <el-form-item label="凭证">
          <div style="display: flex">
            <el-image
              style="width: 80px; height: 80px"
              :src="item"
              alt=""
              :key="index"
              :preview-src-list="tongMsg.image"
              v-for="(item, index) in tongMsg.image"
            />
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="previewImageVisible" width="40%" center>
      <img :src="previewImageUrl" style="width:100%" />
    </el-dialog>
    <el-dialog title="请输入密码" :visible.sync="bigOrderDialog" width="20%">
      <div style="height: 100px">
        <el-input
          placeholder="请输入密码"
          v-model="bigOrderkinput"
          show-password
        ></el-input>
        <div style="margin-top: 20px; display: flex; justify-content: center">
          <el-button type="primary" @click="bigOrderqd()">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Fengkon from "../../fengkong/operation/detail.vue";
import ZHENGXIN from "../../fengkong/operation/detail1.vue";
import ZHENGXINA from "../../fengkong/operation/detail1a.vue";
import YIDUN from "../../fengkong/operation/detail2.vue";
import MAYILIANDAIKOU from "../../fengkong/operation/detail3.vue";
import BUERZHENGXIN from "../../fengkong/operation/detail4.vue";
import DAIKUANBAOGAO from "../../fengkong/operation/detail5.vue";
import YUQIBAOGAO from "../../fengkong/operation/detail6.vue";
import YHZX from "../../fengkong/operation/detail7.vue";
import REMARK from "../../fengkong/operation/remark.vue";
import ZUXIANZHI from "../../fengkong/operation/zuXianZhi.vue";
import ZHANGQIAN from "../../fengkong/operation/zhangQian.vue";
import LSREPORT from "../../fengkong/operation/flowReport.vue";
import XINYAN from "../../fengkong/operation/xinYan.vue";
import HZCreditReport from "../../fengkong/operation/HangzhouCreditReport.vue";
import DUANXIN from "../../fengkong/operation/duanxinindex.vue";
import OrderApi from "@/api/order.js";
import FengkongApi from "@/api/fengkong.js";
import { deepClone } from "@/utils/base.js";
import changeAddress from "@/components/order/changeAddress.vue";
import Table from "../../product/product/part/spec/many/Table.vue";
import Shen from "./dialog/shenhe.vue";
import LIANXI from "./dialog/lianxi.vue";
import { timeFormat } from "@/utils/timeFormat.js";
import SettingApi from "@/api/setting.js";
import useApi from "@/api/useApi.js";
import WindShied from "../../fengkong/operation/windShied.vue";
import AntRepay from "./dialog/AntWithHold/AntReplay.vue";
import FileApi from "@/api/file.js";
async function refund(row) {
  const { msg } = await useApi().orderRefund({ bill_id: row.bill_id });
  this.$message.info(msg);
}

function openRepayDialog(row) {
  this.$refs.antRepayRef.open(row);
}

async function createActivePay(row) {
  const { msg, code } = await useApi().createActivePay({
    order_id: row.order_id,
    period: row.current_period
  });

  code === 1 && this.$message.success(msg);
}

async function getUserTradeInfo(row) {
  const { msg, data } = await useApi().getUserTradeInfo({
    order_id: row.order_id,
    period: row.current_period
  });

  msg === "success" && this.$message.success("查询成功");

  this.getParams();
}

export default {
  components: {
    WindShied,
    changeAddress,
    Shen,
    Fengkon,
    ZHENGXIN,
    YIDUN,
    MAYILIANDAIKOU,
    BUERZHENGXIN,
    DAIKUANBAOGAO,
    YUQIBAOGAO,
    Table,
    DUANXIN,
    LIANXI,
    ZHENGXINA,
    YHZX,
    REMARK,
    ZUXIANZHI,
    ZHANGQIAN,
    LSREPORT,
    XINYAN,
    HZCreditReport,
    AntRepay
  },
  data() {
    return {
      birthday: "",
      srcList1: [], //图片预览
      srcList2: [], //图片预览
      accept: "",
      order_surety: {}, //担保信息
      input: "",
      radio: 2,
      dialogVisible: false,
      document_id: "",
      dialogReason: false,
      reason: "", //公证取消原因
      xml_data: "",
      leaseTerm: "", //租期期数
      /*结清*/
      jqform: {
        /*结清金额*/
        value: "",
        /*结清类型*/
        type: ""
      },
      dialogyq: false,
      /*结清类型列表*/
      jieqingList: [
        {
          type: "逾期 (1-30天)",
          value: 1
        },
        {
          type: "逾期 (31-60天)",
          value: 2
        },
        {
          type: "逾期(61-90天)",
          value: 3
        },
        {
          type: "逾期(91-120天)",
          value: 4
        },
        {
          type: "逾期(121天-150天)",
          value: 5
        },
        {
          type: "逾期(151天-180天)",
          value: 6
        },
        {
          type: "逾期 (180天以上)",
          value: 7
        }
      ],
      creditInvestigationList: "",
      zuxz: "",
      dialogVisiblewlfh: false,
      zdhkbill_id: "",
      zdhkinput: "",
      dialogVisiblezdhk: false,
      lease_type: "",
      order_id: "",
      panduan: "",
      maiduan: "",
      ysqyjze: "",
      buy_out_price: "",
      create_timedata: "",
      portrait: "",
      hasrenzheng_id: "",
      sphxInfo: "",
      yijiao: "",
      coupon_money: "",
      weihuan: "",
      pricezq: "",
      payable: "",
      total_price: "",
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      orderList: [],
      dialogVisiblexd: false,
      xingbie: "",
      addressdd: "",
      dataCount: "",
      ysinfo: "",
      tjbzinput: "",
      dialogVisibletjbz: false,
      wlList: [],
      dialogVisiblewl: false,
      age: "", //年龄
      show: 1, //展示风控 订单详情
      baseurl: "https://leniu.cn-feeling.com/",
      shenhe: false,
      shneheList: [],
      orderBill: [],
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      detail: {
        pay_status: [],
        pay_type: [],
        delivery_type: [],
        user: {},
        address: [],
        product: [],
        order_status: [],
        extract: [],
        extract_store: [],
        express: [],
        delivery_status: [],
        extractClerk: []
      },
      // 以租代购手机照片
      supply_files: [],
      dialogFile: false,
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        express_id: 10001,
        /*订单号*/
        express_no: "",
        //设备编号
        equipment_no: "",
        is_delivery: 10
      },
      forms: {
        is_cancel: 1
      },
      extract_form: {
        order: {
          extract_clerk_id: "",
          extract_status: 1
        }
      },
      order: {},
      delivery_type: 0,
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {},
      /*时间*/
      create_time: "",
      /*操作备注*/
      beizhu: [],
      /*快递公司列表*/
      expressList: [],
      shopClerkList: [],
      /*是否打开编辑弹窗*/
      open_edit: false,
      isChange: false,
      addressData: {
        name: "",
        phone: "",
        region: {
          province: "",
          province_id: 0,
          city: "",
          city_id: 0,
          region: "",
          region_id: 0,
          detail: ""
        }
      },
      riskCtrl: {
        /*风控开关*/
        br_status: "", // 百融
        bl_status: "", // 布尔
        zq_status: "", // 掌签
        zx_info_status: "", // -> 浩程达
        zxz_status: "", // 租先知
        xy_status: "", // 新颜
        ls_report: "" // 流水报告
      },
      credit_url: "",
      // 还款参数
      repayRecord: {
        contractNo: "", //合同编号
        period: "", //还款期数
        repayAmount: "", //还款金额，单位分
        repayTime: "" //还款时间
      },
      // 结清参数
      contractNo: "", //订单号
      settleDate: "", //结清时间
      // 总期数
      lease_time: "",
      reportUrl: "", // 流水报告
      // 订单号
      order_no: "",
      LJCodeUrl: "",
      showLJCodeDia: false,
      changeOrderStatusVis: false,
      accept: "",
      orderStatus: {
        images: "",
        reason: ""
      },
      this_config: {
        /*上传个数*/
        total: 1,
        file_type: "image"
      },
      tongMsg: {
        description: "",
        image: ""
      },
      tongVis: false,
      logisticsImages: [],
      previewImageUrl: "",
      previewImageVisible: false,
      alipayBigOrder: null,
      bigOrderDialog: false,
      bigOrderkinput: ""
    };
  },
  created() {
    /*获取列表*/
    this.getParams();
    this.setTabs();
    // this.birthday = this.user_num
  },
  methods: {
    bigOrderRefund(row) {
      OrderApi.billRefund({
        bill_id: row.bill_id,
        order_id: this.order_id
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "退款成功"
          });
          this.getParams();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    bigOrderqd() {
      let self = this;
      this.bigOrderDialog = false;
      let params = {
        password: this.bigOrderkinput
      };
      OrderApi.checkpwd2(params, true).then(res => {
        this.bigOrderkinput = "";
        if (res.msg == "操作成功") {
          let data = {
            bill_id: this.zdhkbill_id
          };
          OrderApi.activeRepayment(data, true)
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              }
            })
            .catch(error => {});
        }
      });
    },
    bigOrderActive(row) {
      this.zdhkbill_id = row.bill_id;
      this.bigOrderDialog = true;
    },
    handlePicturePreview(file) {
      this.previewImageUrl = file.url;
      this.previewImageVisible = true;
    },
    handlePictureCardPreview(file) {
      console.log(file);
    },
    UploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: "图片上传中,请等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const formData = new FormData();
      formData.append("iFile", param.file);
      formData.append("group_id", self.activeType);
      formData.append("file_type", self.this_config.file_type);
      FileApi.uploadFile(formData)
        .then(response => {
          loading.close();
          // console.log(response.data);
          self.logisticsImages.push(response.data.file_path);
          console.log(self.logisticsImages);
          param.onSuccess(response.data); // 上传成功的图片会显示绿色的对勾
          // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: "本次上传图片失败",
            type: "warning"
          });
          param.onError();
        });
    },
    handleRemove(file, fileList) {
      let self = this;
      const path_to_remove = file.response ? file.response.file_path : file.url;
      if (path_to_remove) {
        const index = self.logisticsImages.findIndex(p => p === path_to_remove);
        if (index !== -1) {
          self.logisticsImages.splice(index, 1);
        }
      }
      self.fileList = fileList;
    },
    viewTong(data) {
      console.log(data, "data");
      this.tongMsg.description = data.description;
      this.tongMsg.image = JSON.parse(data.images);

      this.tongVis = true;
    },
    fileChange(e) {
      console.log(e);
    },
    statusSubmit() {
      console.log(this.logisticsImages, "logisticsImages");
      let data = {
        bill_split_id: this.zdhkbill_id,
        description: this.orderStatus.description,
        images: this.logisticsImages
      };
      OrderApi.payWithholding(data, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.changeOrderStatusVis = false;
          } else {
            this.changeOrderStatusVis = false;
          }
        })
        .catch(error => {});
    },
    /*上传图片*/
    // UploadImage(param) {
    //   let self = this;
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "图片上传中,请等待",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    //   const formData = new FormData();
    //   formData.append("iFile", param.file);
    //   formData.append("group_id", self.activeType);
    //   formData.append("file_type", self.this_config.file_type);
    //   FileApi.uploadFile(formData)
    //     .then((response) => {
    //       loading.close();
    //       this.orderStatus.images = response.data.file_path;
    //       param.onSuccess(); // 上传成功的图片会显示绿色的对勾
    //     })
    //     .catch((response) => {
    //       loading.close();
    //       self.$message({
    //         message: "本次上传图片失败",
    //         type: "warning",
    //       });
    //       param.onError();
    //     });
    // },
    onBeforeUploadImage(file) {
      return true;
    },
    getBirthday(idNumber) {
      // 截取出生日期部分
      if (idNumber.length === 18) {
        const year = idNumber.substring(6, 10); // 年份
        const month = idNumber.substring(10, 12); // 月份
        const day = idNumber.substring(12, 14); // 日期

        // 拼接成 YYYY-MM-DD 格式的日期字符串
        const birthDate = `${year}-${month}-${day}`;
        this.birthday = birthDate;
      } else {
        console.error("无效的身份证号码");
        return null;
      }
    },
    formattedUTCTime(time) {
      let data = new Date(time * 1000);
      let Y = data.getFullYear() + "-";
      let M =
        (data.getMonth() + 1 < 10
          ? "0" + (data.getMonth() + 1)
          : data.getMonth() + 1) + "-";
      let D = data.getDate() < 10 ? "0" + data.getDate() : data.getDate() + " ";
      let h = data.getHours() + ":";
      let m = data.getMinutes() + ":";
      let s = data.getSeconds();
      return Y + M + D + " " + h + m + s;
    },
    billRefund(e) {
      OrderApi.billRefund({
        bill_split_id: e.bill_split_id,
        order_id: e.order_id
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    stagingRefund(e) {
      OrderApi.refundWithholding({
        bill_split_id: e.bill_split_id
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    recovery(e) {
      OrderApi.restoreWithholding({
        bill_split_id: e.bill_split_id
      }).then(res => {
        if ((res.code = 1)) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        }
      });
    },
    goInfo() {
      // getOrderInfo
      let self = this;
      self.loading = true;
      FengkongApi.getOrderInfo({ order_id: self.order_id }, true)
        .then(data => {
          console.log(data);
          self.loading = false;
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    gosilenceSign() {
      let self = this;
      self.loading = true;
      FengkongApi.silenceSign({ order_id: self.order_id }, true)
        .then(data => {
          console.log(data);
          self.loading = false;
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    downNotaryOrderBtn() {
      console.log(12333333333);
      let self = this;
      self.loading = true;
      FengkongApi.downNotaryOrder({ order_id: self.order_id }, true)
        .then(data => {
          console.log(data);
          if (data.code == 1) {
            window.open(data.data.downloadUrl, "_blank");
            self.loading = false;
            self.getParams();
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 坏账
    billDebt(bill_id, isnot) {
      let self = this;
      let text;
      if (isnot == 1) {
        text = "是否要进行坏账标记?";
      } else {
        text = "是否要进行取消坏账?";
      }
      self
        .$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          OrderApi.billDebt({ bill_id, debt_sttaus: isnot }, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    applyCert(type) {
      let self = this;
      self.loading = true;
      FengkongApi.applyCert({ order_id: self.order_id, type }, true)
        .then(data => {
          console.log(data);
          self.loading = false;
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 获取二维码
    getlujiangCode() {
      let self = this;
      self.loading = true;
      FengkongApi.getQrinfo2(
        {
          order_id: self.order_id,
          user_num: self.detail.usernum
        },
        true
      )
        .then(data => {
          console.log(data);
          self.LJCodeUrl = data.data.data.qrInfos[0].qrUrl;
          self.showLJCodeDia = true;
          self.loading = false;
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 取消申请公证
    cancleOrder() {
      let self = this;
      self
        .$prompt("请输入取消原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
        .then(({ value }) => {
          let obj = {
            order_id: self.order_id,
            reason: value
          };
          self.loading = true;
          FengkongApi.cancleOrder(obj, true)
            .then(data => {
              console.log(data);
              self.loading = false;
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
              self.getParams();
            });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    // 申请公证
    createOrder() {
      let self = this;
      self.loading = true;
      FengkongApi.createOrder({ order_id: self.order_id }, true)
        .then(data => {
          console.log(data);
          self.loading = false;
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    //公证撤销
    certificationClear() {
      let self = this;
      let text = "是否要进行鹭江公证撤销?";
      self
        .$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(({ value }) => {
          let obj = {
            order_id: self.order_id,
            type: 0
          };
          self.loading = true;
          FengkongApi.applyCert(obj, true)
            .then(data => {
              console.log(data);
              self.loading = false;
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
              self.getParams();
            });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },

    refund /** 退款 */,
    openRepayDialog /** 打开蚂蚁链还款弹窗 */,
    getUserTradeInfo /** 获取蚂蚁链交易信息 */,
    createActivePay /** 主动创建代扣 */,
    openImageInNewTab(imageUrl) {
      window.open(imageUrl, "_blank");
    },
    setTabs: async function() {
      const { data } = await SettingApi.storeDetail({}, true);
      const values = data.vars.values;
      Object.keys(this.riskCtrl).map(key => {
        this.riskCtrl[key] = values[key] || "";
      });
      console.log(this.riskCtrl, "riskCtrl");
    },
    // 查看证书
    queryApplyInfo() {
      let self = this;
      self.loading = true;
      let apply_No = self.detail.apply_No;
      OrderApi.queryApplyInfo({ apply_No: apply_No }, true)
        .then(data => {
          if (data.data.data.contract_Url) {
            window.open(data.data.data.contract_Url, "_blank");
          }

          self.loading = false;
          self.$message({
            message: data.msg
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    // 查看公证书
    gogz() {
      let self = this;
      self.loading = true;
      let apply_No = self.detail.apply_No;
      OrderApi.queryApplyInfo({ apply_No: apply_No }, true)
        .then(data => {
          if (data.data.data.notarization_Url) {
            window.open(data.data.data.notarization_Url, "_blank");
          } else {
            self.$message({
              message: "公证书还未生成"
            });
          }

          self.loading = false;
          self.$message({
            message: data.msg
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 公证拒绝
    rejectFqgz() {
      let self = this;
      self
        .$prompt("请输入拒绝原因", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
        .then(({ value }) => {
          console.log(value);
          self.loading = true;
          let apply_No = self.detail.apply_No;
          let id_Number = self.detail.usernum;
          OrderApi.gzReject(
            { apply_No: apply_No, Reason: value, id_Number: id_Number },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg
              });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    // 公证同意
    tYFqgz() {
      let self = this;
      self
        .$confirm("是否要进行公证同意操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          self.loading = true;
          let apply_No = self.detail.apply_No;
          OrderApi.gzApproval({ apply_No: apply_No }, true)
            .then(data => {
              self.loading = false;
              self.getParams();

              // self.$message({
              //   message: data.msg,
              // });
              self.getParams();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    // 公证取消
    reasonData() {
      let self = this;
      self.loading = true;
      let apply_No = self.detail.apply_No;
      OrderApi.gzCancel({ apply_No: apply_No, reason: this.reason }, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "取消成功",
            type: "success"
          });
          self.dialogReason = false;
          self.reason = "";
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 扣款
    deductMoney(value) {
      OrderApi.Deductmoney({
        order_id: value.order_id,
        bill_id: value.bill_id
      }).then(res => {
        this.$message({
          type: "success",
          message: "扣款成功"
        });
      });
    },
    // 修改物流确定
    orderqd() {
      console.log(
        this.detail.express_id,
        this.detail.express_no,
        this.detail.equipment_no
      );
      let self = this;
      let param = {
        express_id: self.detail.express_id,
        express_no: self.detail.express_no,
        equipment_no: self.detail.equipment_no,
        is_delivery: self.detail.delivery_type.value
      };
      if (param.express_id == null) {
        this.$message.error("请选择物流公司");
        return;
      }
      if (param.express_no == "" && param.is_delivery == 10) {
        this.$message.error("请填写物流单号");
        return;
      }
      let order_id = self.order_id;
      OrderApi.checkdelivery(
        {
          param: param,
          order_id: order_id
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "修改物流成功",
            type: "success"
          });
          self.getParams();
          self.dialogVisiblewlfh = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改物流
    xiugai() {
      console.log("修改物流");
      this.dialogVisiblewlfh = true;
    },
    //结清
    detailJQ() {
      this.$confirm("是否要进行结清?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          let Params = {
            order_id: this.order_id
          };
          FengkongApi.close(Params, true)
            .then(res => {
              console.log("成功", res);
              this.getParams();
              this.$message({
                type: "success",
                message: "操作成功"
              });
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //逾期
    detailYQ() {
      this.dialogyq = true;
    },
    //逾期确定
    orderjq() {
      let Params = {
        order_id: this.order_id,
        money: this.jqform.value,
        type: this.jqform.type
      };
      FengkongApi.csdefault(Params, true)
        .then(res => {
          this.getParams();
          this.$message({
            message: "操作成功",
            type: "success"
          });
        })
        .catch(error => {});
    },
    // 下载用户授权协议和个人信息授权书
    adwenjian(fid) {
      // console.log("下载用户授权协议和个人信息授权书",this.order_id,fid);
      this.$confirm("是否要进行下载?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          // console.log("======确定");
          // let Params = {
          //   order_id: this.order_id,
          //   flowid: fid
          // };
          // OrderApi.downloadAgreement(Params, true)
          //   .then((res) => {
          //     // console.log("成功1", res);
          //     if (res.code == 1) {
          //       this.$message({
          //         type: "success",
          //         message: "操作成功",
          //       });
          //     } else {
          //       this.$message({
          //         message: '操作失败',
          //         type: 'warning'
          //       });
          //     }
          //   })
          //   .catch((error) => { });

          let Params = {
            order_id: this.order_id
          };
          OrderApi.downloadByAttachName(Params, true)
            .then(res => {
              console.log("成功", res);
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "操作成功"
                });
              } else {
                this.$message({
                  message: "操作失败",
                  type: "warning"
                });
              }
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 取消买断
    quxiaomaiduan() {
      this.$confirm("确定要取消买断吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          // console.log("======确定");
          let Params = {
            order_id: this.order_id
          };
          OrderApi.quxiaomaiduan(Params, true)
            .then(res => {
              // console.log("成功1", res);
              this.$message({
                type: "success",
                message: "确认成功"
              });
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 逾期代偿报送
    zhengxin(row) {
      this.$confirm("确定要逾期代偿报送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          let self = this;
          self.dialogTableVisible1 = true;
          console.log("还款", row);
          let Params = {
            order_id: row.order_id,
            billid: row.bill_id
          };
          OrderApi.yqhkbs(Params, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "确认成功"
              });
              self.getParams();
              self.sanyaosu = res.data.result;
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 主动还款报送
    zhengxin1(row) {
      this.$confirm("确定要主动还款报送?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          let self = this;
          self.dialogTableVisible2 = true;
          // console.log("还款", row);
          let Params = {
            order_id: row.order_id,
            billid: row.bill_id
          };
          OrderApi.hkbs(Params, true)
            .then(res => {
              this.$message({
                type: "success",
                message: "确认成功"
              });
              self.sanyaosu = res.data.result;
              self.getParams();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 扣款
    deductMoney(value) {
      OrderApi.Deductmoney({
        order_id: value.order_id,
        bill_id: value.bill_id
      }).then(res => {
        this.$message({
          type: "success",
          message: "扣款成功"
        });
      });
    },
    // 蚂蚁链退款
    mylRefund(period, order_id) {
      this.$confirm("确定要进行操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          let self = this;
          let Params = {
            order_id: order_id,
            period: period
          };
          OrderApi.createRefund(Params, true)
            .then(res => {
              // console.log("成功", res);
              // self.sanyaosu = res.data.result;
              self.$message({
                type: "success",
                message: "确认成功"
              });
              self.getParams();
              // console.log("sanyaosu", self.sanyaosu);
            })
            .catch(error => {});
        })
        .catch(() => {
          let self = this;
          self.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 主动还款
    zdhk1(row) {
      console.log("主动还款", row.bill_id);
      this.zdhkbill_id = row.bill_split_id;
      this.dialogVisiblezdhk = true;
    },
    // 自动还款密码
    zdhkqd() {
      console.log("主动还款", this.zdhkinput);
      this.dialogVisiblezdhk = false;
      let Params = {
        password: this.zdhkinput
      };
      OrderApi.checkpwd2(Params, true)
        .then(res => {
          console.log(res);
          this.zdhkinput = "";
          if (res.msg == "操作成功") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.changeOrderStatusVis = true;
            // let data = {
            //   bill_split_id: this.zdhkbill_id
            // };
            // OrderApi.payWithholding(data, true)
            //   .then(res => {
            //     console.log(res);
            //   })
            //   .catch(error => { });
          } else {
            this.$message({
              message: "操作失败",
              type: "warning"
            });
          }
        })
        .catch(error => {});
    },
    // 逾期代偿报送  主动还款报送
    huankuan() {
      this.$confirm("确定要进行操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      })
        .then(() => {
          // console.log("this", this.order_id);
          let self = this;
          self.dialogTableVisible2 = true;
          let Params = {
            orderid: self.order_id
          };
          OrderApi.zhengyin(Params, true)
            .then(res => {
              // console.log("成功", res);
              self.sanyaosu = res.data.result;
              self.$message({
                type: "success",
                message: "确认成功"
              });
              // console.log("sanyaosu", self.sanyaosu);
            })
            .catch(error => {});
        })
        .catch(() => {
          let self = this;
          self.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    // 点击订单号跳转
    tiaozdd(id) {
      // console.log(id);
      let self = this;
      let params = id;
      let routeData = self.$router.resolve({
        path: "/order/order/Detail",
        query: { order_id: params }
      });
      window.open(routeData.href, "_blank");
    },
    // 相同下单弹窗
    oderTotal() {
      this.dialogVisiblexd = true;
    },
    // 提交添加商家备注
    tijiaobz() {
      // console.log(this.tjbzinput, this.$route.query.order_id);
      OrderApi.saveopt(
        {
          order_id: this.$route.query.order_id,
          content: this.tjbzinput
        },
        true
      )
        .then(data => {
          this.loading = false;
          this.dialogVisibletjbz = false;
          this.tjbzinput = "";
          this.$message({
            message: "操作成功",
            type: "success"
          });
        })
        .catch(error => {
          this.loading = false;
        });
    },
    shuaxin() {
      this.loading = true;
      this.getParams();
    },
    // 添加备注
    tjbz() {
      this.dialogVisibletjbz = true;
    },
    // 跳转身份证
    sfztz(url) {
      window.open(url, "_blank");
    },
    // 查询物流
    wldh() {
      // console.log(this.$route.query.order_id, this.detail.express_no);
      OrderApi.queryWL(
        {
          order_id: this.$route.query.order_id
        },
        true
      )
        .then(data => {
          this.loading = false;
          this.dialogVisiblewl = true;
          // console.log("data", data.data.express.list);
          this.wlList = data.data.express.list;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 显示报告
    ddxq(val) {
      // console.log(val);
      this.show = val;
    },
    showShenhe() {
      // console.log(this.detail.shop_url.length, "地址信息");
      this.order_id = this.detail.order_id;
      this.shenhe = true;
    },
    next() {
      if (this.active++ > 4) this.active = 0;
    },
    bigOrderDaikou(row) {
      OrderApi.bigOrderBillPay({
        bill_id: row.bill_id
      }).then(res => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "代扣成功"
          });
          this.getParams();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.order_id;
      OrderApi.orderdetail(
        {
          order_id: params
        },
        true
      )
        .then(data => {
          self.srcList1 = [];
          self.srcList2 = [];

          if (data.data.detail.order_surety !== null) {
            self.order_surety = data.data.detail.order_surety;
            self.srcList1.push(self.order_surety.idCard_front);
            self.srcList2.push(self.order_surety.idCard_back);
          }
          self.reportUrl = data.data.report_url;
          self.lease_time = data.data.detail.lease_time;
          self.order_no = data.data.detail.order_no;
          self.xml_data = data.data.xml_data;
          self.credit_url = data.data.credit_url;
          self.creditInvestigationList = data.data.creditInvestigationList;
          self.zuxz = data.data.zuxz;
          self.order_id = data.data.billList[0].order_id;
          self.lease_type = data.data.detail.lease_type;
          self.maiduan = data.data.buy_out_price;
          self.panduan = data.data.detail.user_buyout_states;
          self.loading = false;
          self.detail = data.data.detail;
          self.alipayBigOrder = data.data.alipayBigOrder;
          console.log(data.data.detail, "detail");
          self.supply_files = data.data.supply_files;
          console.log(data.data, "data.data");
          self.buy_out_price = data.data.buy_out_price;
          var buy_out_price = data.data.buy_out_price;
          self.hasrenzheng_id = data.data.detail.hasrenzheng_id;
          self.leaseTerm = data.data.billList.length;

          const date = new Date(data.data.detail.create_time);
          const getTimeSJ = date.getTime();
          // console.log(date.getTime(),"date");
          let cycle = (86400000 * 30 + 3) * self.leaseTerm;
          // console.log(cycle + getTimeSJ);
          self.create_timedata = timeFormat(cycle + getTimeSJ);

          // let str1 = data.data.detail.create_time;
          // console.log(str1.indexOf("2023") != -1,str1,"是否存在");
          // if (str1.indexOf("2023") != -1) {
          // console.log("存在");
          // console.log(str1.replace(/2023/,"2024"));
          // self.create_timedata = str1.replace(/2023/, "2024");
          // }

          self.orderList = Object.values(data.data.orderList);
          self.addressdd = data.data.address;
          self.dataCount = data.data.dataCount;
          self.expressList = data.data.expressList;
          self.beizhu = data.data.beizhu;
          // console.log("self.detail", self.detail.remarks_risk, self.detail.remarks_operation, self.detail.update_time);
          let beizhu1 = {
            app_id: 10001,
            content: self.detail.remarks_risk,
            create_time: self.detail.update_time,
            opt_log_id: 42,
            order_id: 1519,
            real_name: "管理员",
            shop_user_id: 10001,
            title: "",
            type:
              self.detail.order_status.value == 40
                ? "已驳回"
                : self.detail.state_text,
            user_name: ""
          };
          let beizhu2 = {
            app_id: 10001,
            content: self.detail.remarks_operation,
            create_time: self.detail.update_time,
            opt_log_id: 42,
            order_id: 1519,
            real_name: "管理员",
            shop_user_id: 10001,
            title: "",
            type:
              self.detail.order_status.value == 40
                ? "已驳回"
                : self.detail.state_text,
            user_name: ""
          };
          // console.log("beizhu1",beizhu1);
          self.beizhu.push(beizhu1);
          self.beizhu.push(beizhu2);
          if (data.data.ysinfo != null) {
            self.ysinfo = data.data.ysinfo;
          }
          self.shopClerkList = data.data.shopClerkList;
          self.addressData = self.detail.address;
          self.orderBill = data.data.billList;
          self.getsfz(self.detail.usernum);
          self.getBirthday(self.detail.usernum);
          self.getxb(self.detail.usernum);
          // console.log(self.ysinfo, "ysinfo");
          // console.log("detail", data.data.detail);
          let yushou = self.detail.yushou;
          if (self.detail.is_yushou != 2) {
            yushou = 0;
          }
          let depositData = self.detail.deposit;
          let zhuanzujinData = self.detail.zhuanzujin;
          if (self.detail.auth_no == "") {
            depositData = 0;
          }
          if (self.detail.maiduan_no == "") {
            buy_out_price = 0;
          }
          self.detail.order_price = (
            Number(self.detail.order_price) -
            Number(self.detail.deposit) -
            Number(zhuanzujinData)
          ).toFixed(2);
          let yujyj = Number(yushou) + Number(depositData);
          let ysqyjze = Number(zhuanzujinData) + Number(depositData);
          self.ysqyjze = ysqyjze.toFixed(2);
          // console.log(yujyj, "yushouyushou");
          self.total_price =
            Number(self.detail.total_price) + yujyj + +Number(zhuanzujinData);
          self.coupon_money =
            Number(self.detail.coupon_money) +
            Number(self.detail.coupon_money_sys);
          var str = self.detail.product[0].product_attr;
          // console.log(str.indexOf("不用") != -1, str, "是否存在");
          if (str.indexOf("不用") != -1 || str.indexOf("不") != -1) {
            // console.log("没有选择碎屏换新", str.indexOf("不用") != -1);
            self.sphxInfo = "否";
          } else {
            // console.log("选择了碎屏换新", str.indexOf("不用") != -1);
            self.sphxInfo = "是";
          }

          let qishu = 1;
          let pricezq = 0;
          let weihuan = 0;
          let payable = 0;
          for (let i = 0; i < self.orderBill.length; i++) {
            let order = self.orderBill[i];
            let order_id = order.order_id;

            if (order.is_pay_status == 1) {
              pricezq = Number(pricezq) + Number(order.price);
              if (order.transaction_id != null) {
                payable = Number(payable) + Number(order.price);
              }
            } else if (order.is_pay_status == 0) {
              weihuan = Number(weihuan) + Number(order.price);
            } else if (order.is_pay_status == 2) {
              weihuan = Number(weihuan) + Number(order.price);
            }
            self.pricezq = pricezq.toFixed(2);
            self.weihuan = weihuan.toFixed(2);
            self.payable = (payable + ysqyjze + Number(yushou)).toFixed(2);
            // self.yijiao = Number(yujyj) + Number(pricezq) + Number(self.detail.zhuanzujin) + Number(buy_out_price);
            // console.log(
            //   yujyj,
            //   pricezq,
            //   payable,
            //   data.data.detail.zhuanzujin,
            //   "yijiaoyijiao"
            // );

            //扣款时间
            let date = new Date(order.create_time * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? "0" + d : d; //天补0
            let h = date.getHours();
            h = h < 10 ? "0" + h : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s; //秒补0
            var shijian = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
            self.orderBill[i].shijian = shijian;

            //支付时间
            let date1 = new Date(order.repayment_date * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y1 = date1.getFullYear();
            let MM1 = date1.getMonth() + 1;
            MM1 = MM1 < 10 ? "0" + MM1 : MM1; //月补0
            let d1 = date1.getDate();
            d1 = d1 < 10 ? "0" + d1 : d1; //天补0
            let h1 = date1.getHours();
            h1 = h1 < 10 ? "0" + h1 : h1; //小时补0
            let m1 = date1.getMinutes();
            m1 = m1 < 10 ? "0" + m1 : m1; //分钟补0
            let s1 = date1.getSeconds();
            s1 = s1 < 10 ? "0" + s1 : s1; //秒补0
            var shijian1 =
              y1 + "-" + MM1 + "-" + d1 + " " + h1 + ":" + m1 + ":" + s1;
            self.orderBill[i].shijian1 = shijian1;
            self.orderBill[i].qishu = qishu;
            qishu++;

            // console.log("is_pay_status", order.is_pay_status);
            if (order.is_pay_status == 0) {
              order.is_pay_status = "未还";
            } else if (order.is_pay_status == 1) {
              order.is_pay_status = "已还";
            } else {
              order.is_pay_status = "逾期";
            }

            if (order.active_repayment == 0) {
              order.active_repayment = "未进行主动还款";
            } else if (order.active_repayment == 1) {
              order.active_repayment = "主动还款";
            }

            if (order.refund_status_myl == 0) {
              order.refund_status_myl = "未退款";
            } else if (order.refund_status_myl == 1) {
              order.refund_status_myl = "已退款";
            }
            // console.log("refund_status_myl",order.active_repayment,order.refund_status_myl);
            self.orderBill[i].jieguo = order.is_pay_status;

            if (data.data.detail.yj_fail_msg == "") {
              if (
                data.data.detail.order_status.value == "40" ||
                data.data.detail.order_status.value == "20"
              ) {
                data.data.detail.yj_fail_msg1 = "成功";
              } else {
                data.data.detail.yj_fail_msg1 = "";
              }
            } else {
              data.data.detail.yj_fail_msg1 = "失败";
            }

            if (data.data.detail.ys_fail_msg == "") {
              if (
                data.data.detail.order_status.value == "40" ||
                data.data.detail.order_status.value == "20"
              ) {
                data.detail.ys_fail_msg2 = "成功";
              } else {
                data.data.detail.ys_fail_msg2 = "";
              }
            } else {
              data.data.detail.ys_fail_msg2 = "失败";
            }
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    // 身份证换算成年龄
    getsfz(iden) {
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;

        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

        if (
          iden.substring(8, 10) < month ||
          (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)
        )
          age++;
      }

      this.age = age;
    },

    // 身份证换算成年龄
    getxb(iden) {
      // console.log("fdsafsadfsa", iden);
      var str2 = iden;
      var num = str2.charAt(16);
      if (num % 2 == 0) {
        // console.log("女");
        this.xingbie = "女";
      } else if (num % 2 == 1) {
        // console.log("男");
        this.xingbie = "男";
      } else {
        // console.log("未知");
        this.xingbie = "未知";
      }
    },

    /*发货*/
    onSubmit() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error("请选择物流公司");
        return;
      }
      if (param.express_no == "" && param.is_delivery == 10) {
        this.$message.error("请填写物流单号");
        return;
      }
      let order_id = this.$route.query.order_id;
      OrderApi.delivery(
        {
          param: param,
          is_delivery: param.is_delivery,
          order_id: order_id
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，发货成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*确认取消*/
    confirmCancel() {
      let self = this;
      let order_id = this.$route.query.order_id;
      let is_cancel = self.forms.is_cancel;
      OrderApi.toExamine(
        {
          order_id: order_id,
          is_cancel: is_cancel
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，审核成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 关闭弹窗
    closeShenhe(e, f) {
      if (f == "edit") {
        this.shenhe = e.openDialog;
        this.getParams();
      }
    },

    /*核销*/
    onExtract(e) {
      let self = this;
      let extract_form = self.extract_form;
      extract_form.order_id = e;
      OrderApi.extract(
        {
          extract_form
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，操作成功",
            type: "success"
          });
          self.getParams();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        this.getParams();
      }
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    changeAdd() {
      this.isChange = true;
    },
    changeSupplyFile() {
      this.dialogFile = true;
    },
    reasonPass() {
      let self = this;
      self
        .$confirm("确定要进行操作?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info"
        })
        .then(() => {
          OrderApi.verifySupplyFile(
            { order_id: self.order_id, status: 1 },
            true
          ).then(data => {
            self.$message({
              type: "success",
              message: "提交成功"
            });
          });
        })
        .catch(() => {
          self.$message({
            type: "info",
            message: "取消操作"
          });
        });
    },
    reasonRefusal() {
      // this.document_id = item.document_id;
      this.dialogVisible = true;
    },
    submitFunc() {
      let self = this;
      OrderApi.verifySupplyFile(
        {
          order_id: self.order_id,
          status: 2,
          reason: self.input
        },
        true
      )
        .then(data => {
          self.$message({
            message: "驳回成功",
            type: "success"
          });
          self.dialogVisible = false;
          self.input = "";
        })
        .catch(error => {
          self.loading = false;
        });
    },
    closeAddress(e) {
      let self = this;
      if (e == false) {
        self.isChange = false;
        return false;
      }
      let params = e.params;
      params.order_id = self.$route.query.order_id;
      OrderApi.updateAddress(params, true)
        .then(data => {
          self.$message({
            message: "修改成功",
            type: "success"
          });
        })
        .catch(error => {});
      self.isChange = false;
    },
    // 还款
    repay(row) {
      // 生成还款计划
      OrderApi.getBill({
        order_id: row.order_id
      }).then(res => {
        let arr = JSON.parse(res.data);
        arr.forEach(item => {
          if (item.period == row.current_period) {
            this.repayRecord.repayAmount = item.totalRepay; //还款金额  单位分
          }
        });
        let date = new Date();
        let Y = date.getFullYear() + "-";
        let M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        let D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        let H = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        let MI =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        let S =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        this.repayRecord.repayTime = Y + M + D + H + ":" + MI + ":" + S; //时间 年-月-日 时:分:秒
        this.repayRecord.period = row.current_period; //还款期数
        this.repayRecord.contractNo = this.order_no; //还款期数
        // // 还款
        OrderApi.creditRepay(
          { repayRecord: JSON.stringify([this.repayRecord]) },
          true
        )
          .then(data => {
            this.$message({
              message: "还款成功",
              type: "success"
            });
            if (this.lease_time == this.repayRecord.period) {
              this.settle();
            }
          })
          .catch(error => {});
        // 如果是最后一期 则调用结清
        if (this.lease_time == this.repayRecord.period) {
          this.settle();
        }
      });
    },
    // 结清
    settle() {
      let date = new Date();
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let strDate = Y + M + D;
      // // 结清
      OrderApi.creditSettle(
        {
          contractNo: this.order_no,
          settleDate: strDate
        },
        true
      )
        .then(data => {
          this.$message({
            message: "结清成功",
            type: "success"
          });
        })
        .catch(error => {});
    }
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
    formatDate1(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " "; //年月日时分秒
    }
  }
};
</script>
<style lang="scss" scoped>
.dialogFile {
  .el-dialog__header {
    background-color: #d9d9d9;
  }

  .el-dialog__body {
    background-color: #d9d9d9;
  }
}

.bill-children {
  padding-left: 10px;
}

.color49 {
  color: #495060;
}

.xtsh {
  cursor: pointer;
  color: #ffcf00;
  font-weight: bold;
  font-size: 18px;
}

.nav {
  width: 96%;
  height: 70px;
  border-bottom: 1px solid #e8edf0;
  margin: 10px 0;
  display: flex;
  padding: 0 10px;
}

.nav div div {
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #d8e0e6;
  border: 1px solid #d8e0e6;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #7a9191;
  margin-top: 20px;
  margin-right: 6px;
}

.nav div .dtclass {
  background-color: #ffffff;
}

.jbxx {
  width: 100%;
  height: 450px;
  display: flex;
  color: white;
}

.jbxx .j_left {
  width: 25%;
  background-color: #6495ed;
  margin-right: 1%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.jbxx .j_left div {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}

.jbxx .j_left .touximg {
  display: flex;
  justify-content: center;
  color: #f6363e;
}

.jbxx .j_left div img {
  width: 100px;
  height: 100px;
}

.jbxx .j_right {
  width: 70%;
  background-color: #6495ed;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: row;
}

.jbxx .j_right .rleft {
  width: 50%;
}

.jbxx .j_right div {
  margin: 10px 0;
}

.jbxx .j_right div {
  margin: 0;
  line-height: 2.5;
}

.jbxx .j_right .dingdan {
  display: flex;
  align-items: center;
  height: 50px;
  color: white;
}

.dd_title {
  font-size: 16px;
}

.jbxx .j_right .dingdan .d1 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d2 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d3 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .rright {
  width: 50%;
}

.jbxx .j_right .rright div {
  margin-bottom: 30px;
}

.jbxx .j_right .rright div img {
  width: 200px;
  height: 130px;
}

.orderlist {
  display: flex;
  justify-content: flex-start;
}

.d4 {
  width: 80px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
}

.anniu {
  margin-bottom: 5px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/detail.vue